import { Container } from "./styles";
import emailIcon from "../../assets/icons/email-icon.svg";

export function Contact() {
  return (
    <Container id="contact">
      <header>
        <h2>Reach out for queries</h2>
        <p>We will get back with u asap!</p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:freedanjeremiah.25it@licet.ac.in.com">
            freedanjeremiah.25it@licet.ac.in
          </a>
        </div>
      </div>
    </Container>
  );
}
